<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{on}">
        <v-btn
            v-on="on"
            icon
            flat
            @click="showOutbox = true"
        >
          
          <v-badge
              :color="failedMessages > 0 ? 'error' : sendingMessages > 0 ? 'tBlue' : 'tGreen'"
              left
              overlap
          >
            <template #default>
              <v-icon>outbox</v-icon>
            </template>
            
            <template #badge>
              <transition
                  enter-active-class="scale-in-center"
                  leave-active-class="scale-out-center"
                  mode="out-in"
              >
                <v-icon key="error" v-if="failedMessages">priority_high</v-icon>
                <v-icon key="safe" v-else-if="!sendingMessages">check</v-icon>
                <span v-else :key="sendingMessages" class="white--text caption">{{ sendingMessages }}</span>
              </transition>
            </template>
          </v-badge>
        </v-btn>
      </template>
      <span>Mail Outbox</span>
    </v-tooltip>
    
    
    <app-input-dlg
        v-if="showOutbox"
        :show-dialog="showOutbox"
        title="Mail Outbox"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="showOutbox = false"
        :body-padding="false"
        :width="600"
    >
      <template slot="body">
        
        <div v-if="loadingOutbox" class="pa-2 text-xs-center">
          <v-progress-circular
              :size="40"
              :width="5"
              color="primary"
              indeterminate
          />
        </div>
        
        <div v-else style="max-height: 70vh" class="scrollable px-2 py-1 pt-2 page-back">
          <div v-if="outboxMessages.length === 0" class="pa-2 grey--text text-xs-center">
            Mail Outbox is empty
          </div>
          
          <div v-else v-for="(message, i) in outboxMessages" :key="message.sendGuid" class="c-d-flex c-align-center hover-item" style="width: 100%; overflow-x: hidden;">
            
            <div class="py-2 pl-2 pr-1">
              <v-icon :color="message.status === 'SENDING' ? 'tBlue' : 'error'">{{message.status === 'SENDING' ? 'pending' : 'warning'}}</v-icon>
            </div>
            
            <div class="caption c-flex-grow-1 px-1">
              <div>
                {{message.subject}}
              </div>
              <div class="c-d-flex c-justify-space-between">
                <div :class="message.status === 'SENDING' ? 'tBlue--text' : 'error--text'">
                  {{ message.status }}
                </div>
                <div class="caption grey--text">
                  {{ format(new Date(message.created), 'YYYY-MM-DD hh:mm a')  }}
                </div>
              </div>
              <div class="grey--text" v-if="message.lastError">
                {{message.lastError}}
              </div>
            </div>
            
            <div class="pr-2 pl-1">
              
              <v-tooltip bottom>
                <template #activator="{on}">
                  <v-btn
                      v-on="on"
                      icon
                      flat
                      small
                      class="pa-0 ma-0"
                      @click="removeMail(message.sendGuid)"
                      color="error"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove from outbox</span>
              </v-tooltip>
              <v-tooltip bottom :disabled="message.status === 'SENDING' && differenceInMinutes(new Date(), new Date(message.created)) <= 5">
                <template #activator="{on}">
                  <v-btn
                      :disabled="message.status === 'SENDING' && differenceInMinutes(new Date(), new Date(message.created)) <= 5"
                      v-on="on"
                      icon
                      flat
                      small
                      class="pa-0 ma-0"
                      :loading="message.status === 'SENDING' && differenceInMinutes(new Date(), new Date(message.created)) <= 5"
                      @click="retryMail(message.sendGuid)"
                  >
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </template>
                <span>Retry Sending</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </template>
      <template slot="actions">
      </template>
    </app-input-dlg>
  
  </div>
</template>

<script>

// outbox message context
// {
//   "sendGuid": "72dd02ca-7050-4a8d-bb51-df204e332d1e",
//     "userId": 1,
//     "status": "SENT",
//     "created": "2025-01-06T11:58:38.000Z",
//     "lastError": null,
//     "subject": null
// }

import {mapGetters} from 'vuex'
import InputDlg from "./InputDlg";
import {blankString, arrPopulated} from "../../codeFunctions";
import format from "date-fns/format";
import {feed} from "@/feedSocket";
import differenceInMinutes from "date-fns/difference_in_minutes";

export default {
  components: {appInputDlg: InputDlg},
  data() {
    return {
      showOutbox: false,
      loadingOutbox: false,
      outboxMessages: []
    }
  },
  mounted() {
    this.refreshOutbox()
    feed.on('sendQueStatus', this.feedUpdate)
  },
  beforeDestroy() {
    feed.on('sendQueStatus', this.feedUpdate)
  },
  watch: {
    showOutbox: {
      handler(shown) {
        if (shown) {
          this.refreshOutbox()
        }
      }
    }
  },
  methods: {
    differenceInMinutes,
    format,
    blankString: blankString,
    arrPopulated: arrPopulated,
    feedUpdate(data) {
      
      if (data.status === 'SENT') {
        this.outboxMessages = this.outboxMessages.filter(m => m.sendGuid !== data.sendGuid)
        return;
      }
      
      let isUpdated = false
      for (const message of this.outboxMessages) {
        if (message.sendGuid === data.sendGuid) {
          Object.assign(message, data)
          isUpdated = true
          break;
        }
      }
      if (!isUpdated) {
        this.outboxMessages.push(data)
      }
    },
    async retryMail(sendGuid) {
      try {
        this.loadingOutbox = true;
         await this.$newReq('POST', `eml/queMail/send/${sendGuid}`)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingOutbox = false;
      }
    },
    
    async refreshOutbox() {
      try {
        this.loadingOutbox = true;
        this.outboxMessages = await this.$newReq('GET', `eml/queMail/list`)
        console.log(this.outboxMessages)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingOutbox = false;
      }
    },
    
    async removeMail(sendGuid) {
      try {
        this.loadingOutbox = true;
        console.log(sendGuid)
        await this.$newReq('POST', `eml/queMail/remove/${sendGuid}`)
        await this.refreshOutbox()
        // console.log(this.outboxMessages)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingOutbox = false;
      }
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    
    sendingMessages() {
      return this.outboxMessages.length
    },
    failedMessages() {
      return this.outboxMessages.filter(m => m.status === 'ERROR').length
    }
  }
}
</script>

<style scoped>
</style>
